module.exports = __webpack_public_path__ + "img/PL.e94ebf03.jpg";